<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-28                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="12" lg="6" xl="4" v-for="category in sorted_categories" :key="category.id">
        <b-card class="mb-3">
          <b-card-title>
            {{category.name}}
          </b-card-title>
          <b-card-sub-title v-if="!!category.subtitle"  class="mb-2">
            {{category.subtitle}}
          </b-card-sub-title>
          <b-card-text>
            {{category.text}}
            <ul class="mt-3" v-if="bullets(category).length > 0">
              <li v-for="item in bullets(category)">{{item}}</li>
            </ul>
          </b-card-text>
          <b-card-img v-if="!!category.img_src" :src="category.img_src" start>
          </b-card-img>
          <b-button variant="primary" v-on:click="selectCategory(category.id)">Browse</b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: "product-category-subcategory-cards",
  props:{
    subcategories:{
      type: Array,
      required: true
    }
  },
  computed: {
    sorted_categories() {
      return this.subcategories.sort((a, b) => {
        let aVal = a.sort_order;
        let bVal = b.sort_order;
        return ('' + aVal).localeCompare('' + bVal);
      });
    }
  },
  methods:{
    selectCategory(category_id){
      this.$emit('category-selected',category_id);
    },
    bullets(category){
      let result = [];
      if(!!category.bullets){
        const lines = category.bullets.split(/\r?\n/);
        result.push(...lines);
      }
      return result;
    },
  }
}
</script>

<style scoped>

</style>
